export default class StateSelectChateMessage{
    name = '';
    target;
    protoMessages = [];
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/model/stateSelectChatMessage.js